import {
  Theme,
  createStyles,
  lighten,
  makeStyles,
} from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import CopyrightIcon from '@material-ui/icons/Copyright';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import PhoneIcon from '@material-ui/icons/Phone';
import RestaurantMenuIcon from '@material-ui/icons/RestaurantMenu';
import logo from '../assets/img/logo.jpeg';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      backgroundImage: `radial-gradient( circle farthest-corner at -4% -12.9%,  #1b252d 0.3%, ${lighten(
        '#1b252d',
        0.2
      )} 90.2% )`,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexFlow: 'column nowrap',
      padding: '20px 0',
    },
    socialIconsWrapper: {},
    socialIcon: {
      fontSize: 42,
      color: theme.palette.common.white,
      margin: '0 5px',
    },
    copyright: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.common.white,
      margin: 0,
    },
    logo: {
      height: 50,
      borderRadius: 100,
    },
    logoText: {
      color: theme.palette.common.white,
      letterSpacing: 5,
      fontWeight: 'lighter',
      marginLeft: 20,
    },
    phone: {
      color: theme.palette.common.white,
      display: 'flex',
      alignItems: 'center',
      margin: 10,
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
    logoWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
  })
);

export const Footer: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <div className={classes.logoWrapper}>
        <img src={logo} alt='sitelogo' className={classes.logo} />
        <h1 className={classes.logoText}>Little Nino&apos;s</h1>
      </div>
      <Button
        size='large'
        variant='outlined'
        startIcon={<RestaurantMenuIcon />}
        data-glf-cuid='fd3cddaa-823f-4a56-a896-5e9d4513963a'
        data-glf-ruid='31e232a9-0527-4d7f-94d2-324bc669aced'
        style={{ color: 'white', borderColor: 'white', marginBottom: 20 }}
      >
        Order Online
      </Button>
      <div className={classes.socialIconsWrapper}>
        <a
          href='https://www.facebook.com/LittleNinoscafe'
          target='_blank'
          rel='noreferrer'
        >
          <FacebookIcon className={classes.socialIcon} />
        </a>
        <a
          href='https://www.instagram.com/littleninos_cafe/'
          target='_blank'
          rel='noreferrer'
        >
          <InstagramIcon className={classes.socialIcon} />
        </a>
      </div>
      <p className={classes.phone}>
        <PhoneIcon style={{ marginRight: 5 }} /> 0191 447 9797
      </p>
      <p className={classes.phone}>
        3 Cross Morpeth St, Spital Tongues, Newcastle upon Tyne NE2 4AT
      </p>
      <p className={classes.copyright}>
        <CopyrightIcon style={{ marginRight: 5 }} /> 2021 littleninos.co.uk.
      </p>
    </div>
  );
};

export default Footer;
